/* ==========================================================================
   GemofU: "− 1 +" on the product once it is in the bag
   Loaded site-wide from layout/theme.liquid, after gou-cart-ux.js.

   Once an item is in the bag, its Add button turns into a quantity stepper
   showing how many are in the bag, so the shopper can see it has been added
   and change the amount without opening the cart:

     - Product cards (products with one variant): the round "+" becomes a
       small "− 1 +" box in the same corner of the photo.
     - Product page and the quick-view drawer: the Add to Cart button becomes
       a full-width "− 1 +" box with "In your bag · View bag" under it.

   Stock: "+" stops at the number in stock. Cards read it from data-gou-max
   (snippets/product-loop.liquid); product pages read it from the product
   JSON Forge already prints. Products that are not tracked, or that are set
   to keep selling when out of stock, have no limit. Shopify's own check on
   /cart/change.js is the final word, and the stepper resyncs if it refuses.

   Going down to 0 removes the item and brings the Add button back.
   Cart changes made anywhere else (the cart drawer, quick add, the product
   form) are picked up by watching the theme's /cart/ requests.
   ========================================================================== */
(function () {
  'use strict';

  var qtyByVariant = {};   // variant id -> quantity in the bag
  var keyByVariant = {};   // variant id -> cart line key
  var loaded = false;

  var ICON_MINUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7h10"/></svg>';
  var ICON_PLUS = '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 7h10M7 2v10"/></svg>';

  /* ---- Cart state --------------------------------------------------------- */
  function applyCart(cart) {
    if (!cart || !cart.items) return;
    qtyByVariant = {};
    keyByVariant = {};
    cart.items.forEach(function (item) {
      var id = String(item.variant_id);
      qtyByVariant[id] = (qtyByVariant[id] || 0) + item.quantity;
      if (!keyByVariant[id]) keyByVariant[id] = item.key;
    });
    loaded = true;
    updateCounts(cart.item_count);
    render();
  }

  function loadCart() {
    return fetchRaw('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(applyCart)
      .catch(function () {});
  }

  // Header counters. Forge only updates them after its own requests.
  function updateCounts(count) {
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      var text = el.classList.contains('gou-cart-count') ? (count > 0 ? String(count) : '') : String(count);
      if (el.textContent !== text) el.textContent = text;
      el.setAttribute('data-empty', count > 0 ? 'false' : 'true');
    });
  }

  // Rebuild the cart drawer with the new contents, as Forge does after an add.
  function refreshDrawer(cart) {
    try {
      if (!window.WAU || !WAU.AjaxCart || typeof WAU.AjaxCart.updateView !== 'function') return;
      var node = document.getElementById('cart-config');
      if (!node) return;
      WAU.AjaxCart.updateView(JSON.parse(node.innerHTML || '{}'), cart);
    } catch (e) {}
  }

  /* ---- Watching the theme's own cart requests ------------------------------ */
  var fetchRaw = window.fetch.bind(window);
  var syncTimer = null;

  function scheduleSync(delay) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(loadCart, delay || 250);
  }

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url);
    var p = fetchRaw(input, init);
    if (isCartWrite(url)) {
      p.then(function () { scheduleSync(200); }, function () { scheduleSync(200); });
    }
    return p;
  };

  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(url)) {
      this.addEventListener('loadend', function () { scheduleSync(200); });
    }
    return xhrOpen.apply(this, arguments);
  };

  /* ---- Changing a quantity -------------------------------------------------- */
  var pending = {};   // variant id -> { qty, timer }
  var queue = Promise.resolve();

  function setQuantity(variantId, qty) {
    var id = String(variantId);
    qtyByVariant[id] = qty;
    render();

    // Several quick taps are sent as one request with the final number.
    if (pending[id]) clearTimeout(pending[id].timer);
    pending[id] = {
      qty: qty,
      timer: setTimeout(function () {
        var wanted = pending[id].qty;
        delete pending[id];
        queue = queue.then(function () { return sendChange(id, wanted); });
      }, 280)
    };
  }

  function sendChange(id, qty) {
    var body = keyByVariant[id] ? { id: keyByVariant[id], quantity: qty } : { id: id, quantity: qty };
    var req = fetchRaw('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    });
    return req
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.items) {
          flash(id, (res.data && (res.data.description || res.data.message)) || 'That could not be updated');
          return loadCart();
        }
        applyCart(res.data);
        refreshDrawer(res.data);
        var got = qtyByVariant[id] || 0;
        if (got < qty) flash(id, 'Only ' + got + ' in stock');
      })
      .catch(function () { return loadCart(); });
  }

  function flash(id, message) {
    document.querySelectorAll('[data-gou-stepper][data-variant-id="' + id + '"]').forEach(function (el) {
      var note = el.parentNode && el.parentNode.querySelector('.gou-bagline__note');
      if (note) note.textContent = message;
      el.classList.remove('gou-stepper--nope');
      void el.offsetWidth;
      el.classList.add('gou-stepper--nope');
    });
  }

  /* ---- Stock limits ------------------------------------------------------- */
  function cardMax(button) {
    var raw = button.getAttribute('data-gou-max');
    var n = parseInt(raw, 10);
    return raw === null || raw === '' || isNaN(n) ? Infinity : n;
  }

  function productVariants(scope) {
    var node = scope.querySelector('script.product-json');
    if (!node) return null;
    if (node._gouVariants) return node._gouVariants;
    try {
      var data = JSON.parse(node.textContent);
      var map = {};
      (data.variants || []).forEach(function (v) {
        var tracked = v.inventory_management === 'shopify' && v.inventory_policy === 'deny';
        map[String(v.id)] = tracked ? Math.max(0, v.inventory_quantity || 0) : Infinity;
      });
      node._gouVariants = map;
      return map;
    } catch (e) {
      return null;
    }
  }

  /* ---- Building the stepper -------------------------------------------------- */
  function makeStepper(variantId, kind) {
    var el = document.createElement('div');
    el.className = 'gou-stepper gou-stepper--' + kind;
    el.setAttribute('data-gou-stepper', '');
    el.setAttribute('data-variant-id', variantId);
    el.setAttribute('role', 'group');
    el.setAttribute('aria-label', 'Quantity in your bag');
    el.innerHTML =
      '<button type="button" class="gou-stepper__btn" data-gou-step="-1" aria-label="Remove one">' + ICON_MINUS + '</button>' +
      '<span class="gou-stepper__qty" aria-live="polite">1</span>' +
      '<button type="button" class="gou-stepper__btn" data-gou-step="1" aria-label="Add one more">' + ICON_PLUS + '</button>';
    return el;
  }

  function paint(stepper, qty, max) {
    var q = stepper.querySelector('.gou-stepper__qty');
    if (q.textContent !== String(qty)) q.textContent = String(qty);
    var plus = stepper.querySelector('[data-gou-step="1"]');
    var atMax = qty >= max;
    if (plus.disabled !== atMax) plus.disabled = atMax;
    plus.setAttribute('aria-label', atMax ? 'No more in stock' : 'Add one more');
    stepper._max = max;
  }

  /* Product cards */
  function renderCards() {
    document.querySelectorAll('.product-listing__quickview-trigger[data-variant-id]').forEach(function (button) {
      var id = String(button.getAttribute('data-variant-id'));
      var box = button.parentNode;
      if (!box) return;
      var qty = qtyByVariant[id] || 0;
      var stepper = box.querySelector(':scope > [data-gou-stepper]');

      if (qty > 0) {
        if (!stepper) {
          stepper = makeStepper(id, 'card');
          box.appendChild(stepper);
        }
        paint(stepper, qty, cardMax(button));
        if (!box.classList.contains('gou-in-bag')) box.classList.add('gou-in-bag');
      } else {
        if (stepper) stepper.remove();
        if (box.classList.contains('gou-in-bag')) box.classList.remove('gou-in-bag');
      }
    });
  }

  // The nearest ancestor holding Forge's product JSON (product page section
  // or the quick-view drawer).
  function findScope(node) {
    for (var n = node; n && n !== document.body; n = n.parentElement) {
      if (n.querySelector && n.querySelector('script.product-json')) return n;
    }
    return document;
  }

  /* Product page + quick-view drawer */
  function renderForms() {
    document.querySelectorAll('.product__add-container').forEach(function (container) {
      var idInput = container.querySelector('input[name="id"]');
      var addButton = container.querySelector('.js-ajax-submit, button[type="submit"]');
      if (!idInput || !addButton) return;

      var id = String(idInput.value);
      var scope = findScope(container);
      var limits = productVariants(scope) || {};
      var max = limits[id] !== undefined ? limits[id] : Infinity;
      var qty = qtyByVariant[id] || 0;
      var line = container.querySelector(':scope > .gou-bagline');
      var qtyPicker = scope.querySelector('.product__quantity');

      if (qty > 0) {
        if (!line) {
          line = document.createElement('div');
          line.className = 'gou-bagline';
          line.appendChild(makeStepper(id, 'form'));
          var info = document.createElement('p');
          info.className = 'gou-bagline__info';
          info.innerHTML = '<span class="gou-bagline__tick" aria-hidden="true"></span>In your bag &middot; <a href="/cart" class="gou-bagline__view">View bag</a>';
          line.appendChild(info);
          var note = document.createElement('p');
          note.className = 'gou-bagline__note';
          line.appendChild(note);
          container.insertBefore(line, addButton);
        }
        var stepper = line.querySelector('[data-gou-stepper]');
        if (stepper.getAttribute('data-variant-id') !== id) stepper.setAttribute('data-variant-id', id);
        paint(stepper, qty, max);
        var noteEl = line.querySelector('.gou-bagline__note');
        var noteText = qty >= max ? (max === 1 ? 'Only 1 in stock, and it is in your bag.' : 'All ' + max + ' in stock are in your bag.') : '';
        if (noteEl.textContent !== noteText && !stepper.classList.contains('gou-stepper--nope')) noteEl.textContent = noteText;
        if (!container.classList.contains('gou-in-bag')) container.classList.add('gou-in-bag');
        if (qtyPicker && !qtyPicker.classList.contains('gou-hidden-by-bag')) qtyPicker.classList.add('gou-hidden-by-bag');
      } else {
        if (line) line.remove();
        if (container.classList.contains('gou-in-bag')) container.classList.remove('gou-in-bag');
        if (qtyPicker && qtyPicker.classList.contains('gou-hidden-by-bag')) qtyPicker.classList.remove('gou-hidden-by-bag');
      }
    });
  }

  function render() {
    if (!loaded) return;
    renderCards();
    renderForms();
  }

  /* ---- Events ---------------------------------------------------------------- */
  document.addEventListener('click', function (event) {
    var step = event.target.closest && event.target.closest('[data-gou-step]');
    if (step) {
      event.preventDefault();
      event.stopPropagation();
      var stepper = step.closest('[data-gou-stepper]');
      var id = stepper.getAttribute('data-variant-id');
      var current = qtyByVariant[id] || 0;
      var next = current + parseInt(step.getAttribute('data-gou-step'), 10);
      var max = stepper._max === undefined ? Infinity : stepper._max;
      if (next < 0) return;
      if (next > max) { flash(id, max === 1 ? 'Only 1 in stock' : 'Only ' + max + ' in stock'); return; }
      setQuantity(id, next);
      return;
    }

    // "View bag" opens the cart drawer instead of leaving the page.
    var view = event.target.closest && event.target.closest('.gou-bagline__view');
    if (view) {
      var trigger = document.querySelector('.js-mini-cart-trigger');
      if (trigger) {
        event.preventDefault();
        trigger.click();
      }
      return;
    }

  }, false);

  // Quick add on a card: show the stepper straight away, before the request
  // returns (gou-cart-ux.js sends it, and stops the click at the document, so
  // this listens one level higher on window). The sync then confirms it.
  window.addEventListener('click', function (event) {
    var quick = event.target.closest && event.target.closest('.product-listing__quickview-trigger[data-quick-add][data-variant-id]');
    if (!quick) return;
    var vid = String(quick.getAttribute('data-variant-id'));
    var have = qtyByVariant[vid] || 0;
    if (have < cardMax(quick)) {
      qtyByVariant[vid] = have + 1;
      setTimeout(render, 0);
    }
  }, true);

  // Picking another size or colour changes the variant in the form.
  document.addEventListener('change', function () { setTimeout(render, 60); });

  // Cards arrive later (filtering, pagination, quick view): re-render, with
  // a debounce. render() only touches the DOM when something differs, so this
  // cannot loop.
  var moTimer = null;
  function start() {
    loadCart();
    if (document.body) {
      new MutationObserver(function () {
        clearTimeout(moTimer);
        moTimer = setTimeout(render, 150);
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Coming back to the tab after shopping elsewhere.
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') loadCart();
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) loadCart(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
